import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { RootState } from '@redux/store';
import { NewActionModel } from '@models/IActionModel';

interface IState {
  data: {
    actionInfo: NonNullable<NewActionModel>;
    pageProductsByAction?: any;
  };
}

const initialState: IState = {
  data: {
    actionInfo: null,
    pageProductsByAction: null,
  },
};

export const actionCartSlice = createSlice({
  name: 'actionCart',
  initialState,
  reducers: {
    setInitAction: (state, action: PayloadAction<any>) => {
      state.data.actionInfo = action.payload;
    },
    setInitProductsByAction: (state, action: PayloadAction<any>) => {
      state.data.pageProductsByAction = action.payload;
    },
  },
  extraReducers: {
    [HYDRATE]: (state, action) => {
      return {
        ...state,
        ...action.payload.actionCart,
      };
    },
  },
});

export const { setInitAction, setInitProductsByAction } = actionCartSlice.actions;

export const selectActionData = (state: RootState) => state.actionCart.data;
